import { useSessionStore } from '@/stores/useSessionStore'
import { Flex } from '@alpine-iq/ui-library'
import LogoImage from './LogoImage'

export default function CoverImage() {
  const uid = useSessionStore((state) => state.currentUID)
  const popupSettings = useSessionStore((state) => state.widgetSettings?.popupSettings)

  const host = location.origin.replace('lab-dev', 'lab')
  const defaultCoverImage = `${host}/cover/${uid || ''}`
  const enableCoverImage = popupSettings?.enableCoverPhoto
  const coverImage = popupSettings?.images?.coverBackground || defaultCoverImage
  const logoPlacement = popupSettings?.images?.logoPlacement || 'belowCover'

  if (!enableCoverImage || !coverImage) return <div />

  return (
    <Flex center>
      <div style={{ position: 'relative', flex: 1, display: 'flex', justifyContent: 'center' }}>
        {logoPlacement === 'onCover' && (
          <Flex
            column
            gap='16'
            style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
          >
            <LogoImage withinCover />
          </Flex>
        )}
        <img
          src={coverImage}
          alt='cover'
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            maxWidth: 800,
            maxHeight: 200,
          }}
        />
      </div>
    </Flex>
  )
}
